//PROD
// export const BASE_URL = 'https://api.reports.strix.com.ar'
// export const FLEET_BASE_URL = 'https://flotas.strix.com.ar'

//LOCAL
//export const BASE_URL = 'http://localhost:4000'
//export const FLEET_BASE_URL = 'http://localhost:9000'

// TEST
// export const BASE_URL = 'https://lj-test02-v2.api.reports.strix.com.ar'
// export const FLEET_BASE_URL = 'https://lj-test02-v2.web.fleet.strix.com.ar'
// export const BASE_URL = 'https://api-reports.test.aws.flotas.strix.com.ar'


// Dev AWS
//export const BASE_URL = 'https://api-reports.dev.aws.flotas.strix.com.ar'
//export const FLEET_BASE_URL = 'https://dev.aws.fleet.strix.com.ar/'

// Test AWS  
//export const BASE_URL = 'https://api-reports.test.aws.flotas.strix.com.ar' 
//export const FLEET_BASE_URL = 'https://test.aws.fleet.strix.com.ar/'


let apiBaseUrl = 'https://api-reports.dev.aws.flotas.strix.com.ar'
let apiV2BaseUrl = 'https://api-reports-v2.dev.aws.flotas.strix.com.ar'
let fleetBaseUrl = 'https://dev.aws.fleet.strix.com.ar/' 

if (process.env.VUE_APP_API_BASE_URL) {
    apiBaseUrl = process.env.VUE_APP_API_BASE_URL
}

if (process.env.VUE_APP_API_BASE_URL_2) {
    apiV2BaseUrl = process.env.VUE_APP_API_BASE_URL_2
}

if (process.env.VUE_APP_FLEET_BASE_URL) {
    fleetBaseUrl = process.env.VUE_APP_FLEET_BASE_URL
}

console.log('apiBaseUrl',apiBaseUrl)
console.log('apiV2BaseUrl',apiV2BaseUrl)
console.log('feetBaseUrl',fleetBaseUrl)

export const BASE_URL = apiBaseUrl
export const BASE_V2_URL = apiV2BaseUrl
export const FLEET_BASE_URL = fleetBaseUrl